export enum TypeModificationEnum {
  MAJEURE = 1,
  MINEURE= 2
}
